export const Colors = {
	black: "#000000",
	white: "#FFFFFF",
	primary: "#4A9FF8",
	primaryLight: "#F0F8FE",
	success: "#67DE93",
	background: "#F8FBFB",
};
